var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
var ArrowDropDownIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { fillRule: "evenodd", d: "M12.3685771,14.5979159 L16.7319595,9.83786231 C16.9185557,9.63430282 16.9048043,9.31801913 16.7012448,9.13142293 C16.6090299,9.04689259 16.4884783,9 16.3633825,9 L7.63661752,9 C7.36047515,9 7.13661752,9.22385763 7.13661752,9.5 C7.13661752,9.62509584 7.18351012,9.7456474 7.26804045,9.83786231 L11.6314229,14.5979159 C11.8180191,14.8014754 12.1343028,14.8152269 12.3378623,14.6286307 C12.3485407,14.6188422 12.3587886,14.6085943 12.3685771,14.5979159 Z" }))); };
export default ArrowDropDownIcon;
